export default class DtoMaterielSettingRule {
    constructor(obj) {
        this.idMaterielType = obj.idMaterielType
        this.rule = obj.rule
        this.shouldUse = obj.shouldUse
        this.settingRule = obj.settingRule
        this.dateMaj = obj.dateMaj
        this.loginMaj = obj.loginMaj
    }
}